import {ReactNode} from 'react';

import './styles.scss';

interface IProps {
    newStyle?: boolean;
    title?: string;
    subtitle?: string;
    className?: string;
    children: ReactNode;
}

const Card = ({ title, className = '', children, subtitle, newStyle = false }: IProps) => {
    return (
        <div className="row">
            <div className="col-12">
                <div className={`card ${className} ${newStyle && 'card-newStyle'}`}>
                    {
                        newStyle
                        && title
                        &&
                        <div className="card-header">
                            <h4 className="card-title">{title}</h4>
                            {subtitle && <h6 className="card-subtitle">{subtitle}</h6>}
                        </div>
                    }
                    <div className="card-body">
                        {!newStyle && title && <h4 className="card-title mb-3">{title}</h4>}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;